import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../../../../constants/qa'
import { useNotification } from '../../../../../../hooks'
import { ConfirmationModal } from '../../../../../Confirmation'
import {
  getRentalPortalApplicantIdentityLabel,
  postMockApplicantHandoffRetry,
} from '../../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'

import RetryIcon from '../../../../../../icons/refresh.svg'

export function useApplicantProfileHandoffRetry({ handoff, onReload }) {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const {
    applicantData,
    applicantId,
    handleCloseModal,
    handleEntityReload,
    setModal,
  } = useApplicantProfileContext()

  const [isSubmitting, setSubmitting] = useState(false)

  function handleSubmitRetry() {
    setSubmitting(true)

    return postMockApplicantHandoffRetry({ applicantId })
      .then(() => {
        handleCloseModal()

        handleAddSuccessNotification(
          'RentalPortal.ApplicantComplianceHandoffRetryStartedNotificationKey'
        )

        return Promise.all([onReload(), handleEntityReload()])
      })
      .catch(() => {
        handleCloseModal()

        handleAddErrorNotification({
          textButtonValue: t('RentalPortal.ListingRetryBtnKey'),
          title: t('RentalPortal.ApplicantComplianceHandoffRetryErrorKey'),
          onClickTextButton: handleClickRetry,
        })
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  function handleClickRetry() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitProps: { beforeIconProps: { Icon: RetryIcon } },
          submitText: t('RentalPortal.ApplicantComplianceHandoffRetryBtnKey'),
        }}
        description={t(
          'RentalPortal.ApplicantComplianceHandoffRetryConfirmationTextKey',
          {
            label: handoff?.connection?.account_label,
            name: getRentalPortalApplicantIdentityLabel({
              applicant: applicantData,
              t,
            }),
          }
        )}
        qaName={QA_NAME_CONFIRMATION}
        onCancel={handleCloseModal}
        onSubmit={handleSubmitRetry}
      />
    )
  }

  return {
    handleClickRetry,
    isSubmitting,
  }
}
